import { VITE_BASE_URL } from '../utils/config';
import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';

// API
export const validateFileAPI = async (file, jsonContent?) => {
  const formData = new FormData();
  formData.append('file', file);

  const requestId = uuidv4();

  const response = await axios.post(`${VITE_BASE_URL}/verify/post-lite`, formData, {
    withCredentials: true,
    headers: {
      'Content-Type': 'multipart/form-data',
      'x-request-id': requestId,
    },
  });
  // console.log('response', response);
  return response.data;
};

// OLD
// export const validateFileAPIOld = async (file, jsonContent?) => {
//   const formData = new FormData();
//   formData.append('file', file);
//   if (jsonContent) {
//     // Convert JSON data to a Blob and append as a file
//     const jsonBlob = new Blob([JSON.stringify(jsonContent)], { type: 'application/json' });

//     formData.append('jsonproof', jsonBlob, 'proof.json'); // Key should match what the API expects
//   }

//   const headers = {
//     'x-report-required': 'true',
//   };

//   try {
//     const response = await axios.post(`${API_INTEGRITAS_BASEURL}${VERIFY_ENDPOINT}`, formData, {
//       headers,
//       auth: API_INTEGRITAS_AUTH,
//     });
//     return response.data.response;
//   } catch (err) {
//     //console.log(`Err: ${err}`);
//     return { error: `${err}` };
//   }
// };
